import { formatShortDate } from '../../../../ts-utils/date-utils'

/**
 * The calendar day a roster lock date names, as `YYYY-MM-DD`.
 *
 * The API sends either a bare day or that day's UTC midnight
 * (`2026-08-01T00:00:00+00:00`). The time part carries no meaning, so it is
 * dropped rather than converted — converting would shift the day for anyone
 * east or west of UTC. Null when there is no usable date.
 */
export const rosterLockDay = (lockRosterDate: string | null): string | null => {
  const day = (lockRosterDate ?? '').split(/[T ]/)[0]
  return /^\d{4}-\d{2}-\d{2}$/.test(day) ? day : null
}

/** The lock date for display ("Aug 1, 2026"), or null when there is none. */
export const formatRosterLockDate = (
  lockRosterDate: string | null
): string | null => {
  const day = rosterLockDay(lockRosterDate)
  // Parsed as a local calendar day, not an instant, so it reads the same day
  // in every zone.
  return day ? formatShortDate(day, false) : null
}

/**
 * Whether the lock has passed — adding to the roster is blocked from then on.
 * Same comparison as the Team screen (`web/src/pages/Team/index.jsx`), so both
 * surfaces agree on the exact moment the roster locks.
 */
export const isRosterLockPassed = (
  lockRosterDate: string | null,
  now: Date = new Date()
): boolean => (lockRosterDate ? new Date(lockRosterDate) < now : false)
